import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/onramp-logo-white-with-text.svg'


const _withScopeId = n => (_pushScopeId("data-v-b0b5bdf4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container header pt-2 pb-5" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-4 text-start" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "item",
    src: _imports_0
  })
], -1))
const _hoisted_4 = { class: "col-8 text-end" }

import { VUE_APP_ACADEMY_REGISTRATION_LINK } from "@/constants/env.js";
import {ref, inject} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBarLoginSignup',
  setup(__props) {

const ACADEMY_REGISTRATION_LINK = ref(VUE_APP_ACADEMY_REGISTRATION_LINK);
const kc = inject("$kc");
async function login() {
  await kc.login();
}
function goToLink(link: string) {
  window.open(link);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          id: "login-button",
          class: "btn btn-outline-success ms-2 login-button",
          onClick: login
        }, " Login "),
        _createElementVNode("button", {
          id: "signup-button",
          class: "btn btn-outline-success ms-2 signup-button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goToLink(ACADEMY_REGISTRATION_LINK.value)))
        }, " Sign Up ")
      ])
    ])
  ]))
}
}

})